import { createSlice, createAsyncThunk, PayloadAction} from "@reduxjs/toolkit";
import { IUser } from "../api/types";
import { createBrowserHistory } from 'history';
import axiosInstance from "../../utils/httpCommon";

export const browserHistory = createBrowserHistory();

interface UserState {
    loading: boolean
    error: string
    credential: IUser | null
}

const initialState : UserState = {
    loading: false,
    credential: null,
    error: ''
}

export const validateUser = createAsyncThunk('user/credentials', async (credential: Login) => {

    localStorage.removeItem("user")
    
    const response = await axiosInstance.post('/auth/credentials', credential)
        .then((response: any) => {
            return response.data
        })
        .catch((error) => {
            throw new Error(error.response.data.message)
        })

    return response

})

const authSlice = createSlice({
    name: 'credentials',
    initialState,
    reducers: {
        logout: () => initialState,
        setUser: (state, action : PayloadAction<IUser>) => {
            state.credential = action.payload
        }
    },
    extraReducers: (builder) => {

        builder
            .addCase(validateUser.pending, (state, action) => {
                state.loading = true
            })
            .addCase(validateUser.fulfilled, (state, action) => {
                                
                state.loading = false
                state.credential = action.payload
                state.error = ''
                localStorage.setItem('user', JSON.stringify({ roles: action.payload.object.roles, token: action.payload.token }))
                browserHistory.push('/payment/list')
                document.location.reload()
            })
            .addCase(validateUser.rejected, (state, action) => {
                state.loading = false
                state.credential = null
                state.error = action.error.message!.toString()
            })
    }
})

export default authSlice.reducer;

export const { logout, setUser } = authSlice.actions;